/** The line under the icon's message naming the parent accounts that count for it. */
export const parentAccountsLine = (profile) => {
    const names = profile?.parentAccounts ?? [];

    if (!names.length) {
        return '';
    }

    return names.length === 1
        ? `Parent account: ${names[0]}`
        : `Parent accounts: ${names.join(', ')}`;
};
